export default "__VITE_ASSET__f1f63f5b__"